export const getClickableLink = (url: string): string => {
    if (url.startsWith("http")) return url;
    return `http://${url}`;
};